import {
  Directive,
  ElementRef,
  Renderer2,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appAutoExpand]',
})
export class AutoExpandDirective implements AfterViewInit, OnDestroy {
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    this.adjust();

    this.control.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.adjust();
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  adjust(): void {
    this.renderer.setStyle(this.el.nativeElement, 'height', '0px');

    let scrollHeight = this.el.nativeElement.scrollHeight;

    if (scrollHeight < 38) {
      scrollHeight = 38;
    }

    this.renderer.setStyle(
      this.el.nativeElement,
      'height',
      `${scrollHeight + 22.5}px`,
    );
  }
}
